import { createAsyncThunk } from "@reduxjs/toolkit";
import 'react-toastify/dist/ReactToastify.css';

import {
  createProducts,
  getProducts as getProductsApi,
  getDraftProducts as getDraftProductsApi,
  getProductDetail,
  getProductById,
  updateProducts,
  deleteProductById,
  deleteDraftProduct,
  createDraftProducts,
  updateDraftProducts,
  getPrductDraftDetail,
  getProductsByCampaign,
  getProductDetailByUrl,
} from "../../helpers/backend_helper";
import { AddProductDTO } from "helpers/models/product.model";
import { toast } from "react-toastify";

export const getProducts = createAsyncThunk(
  "product/get",
  async ({ page, count, status, keyword,keywordType ,categoryId}: { page: number, count: number, status: string; keyword: string,keywordType?:any ,categoryId?:any}) => {
    try {
      const response = await getProductsApi(page, count, status, keyword,keywordType,categoryId);
      return response.data;
    } catch (error) {
      throw error; // Rethrow the error for proper handling
    }
  }
);

export const getProductsByCampaignThunk = createAsyncThunk(
  "productCampaign/get",
  async ({ page, count, status, keyword,keywordType ,categoryId}: { page: number, count: number, status: string; keyword: string,keywordType?:any ,categoryId?:any}) => {
    try {
      const response = await getProductsByCampaign(page, count, status, keyword,keywordType,categoryId);
      return response.data;
    } catch (error) {
      throw error; // Rethrow the error for proper handling
    }
  }
);

export const getDraftProducts = createAsyncThunk(
  "productDraft/get",
  async ({ page, count, status, keyword, }: { page: number, count: number, status: string; keyword: string }) => {
    try {
      const response = await getDraftProductsApi(page, count, status, keyword);
      return response.data;
    } catch (error) {
      throw error; // Rethrow the error for proper handling
    }
  }
);

const getPayloadFromFormData = (formData: any) => {
  return new AddProductDTO(
    formData.nameEn,
    formData.nameUr,
    formData.categoryId,
    formData.productImages ?? [],
    formData.promotionImage,
    formData.promotionWhiteImageBg,
    formData.productVideo,
    formData.sizeChartImage,
    formData["Product Attributes"],
    formData["Main Description"],
    formData["Product Description"],
    formData["Highlights"],
    formData["What's in the box"],
    formData["Warranty Type"],
    formData["Warranty Period"],
    formData["Warranty Policy"],
    formData["Dangerous Goods"],
    formData.variants,
    formData.packageBySku,
    formData.packageWeight,
    formData.packageWeightUnit,
    formData.packageLength,
    formData.packageWidth,
    formData.packageHeight,
    formData.subProducts,
    formData.draftId
  );
}

export const addProductFromJSON = createAsyncThunk("category/addProductFromJSON", async (formData: any) => {
  try {
    let payload = getPayloadFromFormData(formData);
    const response = await createProducts(payload);
    return response;
  } catch (error) {
    return { isSuccess: false, message: "Please! fill out the complete form" };
  }
});

export const fetchProductDraftDetail = createAsyncThunk(
  'product/fetchDetail',
  async (id: string , { rejectWithValue }) => {
    try {
      const response = await getPrductDraftDetail(id);
      return response.data; 
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const addProductDraftFromJSON = createAsyncThunk("category/addProductDraftFromJSON", async (formData: any) => {
  try {
    let payload = getPayloadFromFormData(formData);
    const response = await createDraftProducts(payload);
    return response;
  } catch (error) {
    return { isSuccess: false, message: "Please! fill out the complete form" };
  }
});

export const updateProductFromJSON = createAsyncThunk("category/updateProductFromJSON", async (data: any) => {
  try {
    let payload = getPayloadFromFormData(data.formData);
    const response = await updateProducts(data.productId, payload);
    return response;
  } catch (error) {
    return { isSuccess: false, message: "Please! fill out the complete form" };
  }
});

export const updateDraftProductFromJSON = createAsyncThunk("category/updateProductFromJSON", async (data: any) => {
  try {
    let payload = getPayloadFromFormData(data.formData);
    const response = await updateDraftProducts(data.draftId, payload);
    return response;
  } catch (error) {
    return { isSuccess: false, message: "Please! fill out the complete form" };
  }
});

export const fetchProductDetail = createAsyncThunk(
  'product/fetchProductDetail',
  async (id: string | number, { rejectWithValue }) => {
    try {
      const response = await getProductDetail(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const fetchProductForEdit = createAsyncThunk(
  'product/getProductById',
  async (id: string | number, { rejectWithValue }) => {
    try {
      const response = await getProductById(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);


export const deleteProduct = createAsyncThunk(
  'product/delete',
  async ({ productId, navigate }: { productId: any; navigate: any }, { rejectWithValue }) => {
    try {
      const response: any = await deleteProductById(productId);
      navigate('/manage-products');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const deleteDraftProductApi = createAsyncThunk("ecommerce/deleteProducts",
  async ({ id, navigate }: { id: any; navigate: any }, { rejectWithValue }) => {
    try {
    const response: any = await deleteDraftProduct(id);
      if (response.isSuccess) {
        navigate('/draft-products');
    // toast.success("Product Delete Successfully", { autoClose: 1000 });
      return id;
    }

    
    toast.error("Draft Product Delete Failed", { autoClose: 1000 });
    return false;
  } catch (error) {
    toast.error("Draft Product Delete Failed", { autoClose: 1000 });
    return error;
  }
});


// export const fetchProductAiData = createAsyncThunk(
//   'product/fetchProductaiData',
//   async (url: string) => {
//     try {
//       const response = await getProductDetailByUrl(url);
//       return response.data;
//     } catch (error: any) {
//       // return rejectWithValue(error.response?.data || 'Something went wrong');
//     }
//   }
// );


export const fetchProductAiData = createAsyncThunk(
  'product/fetchProductaiData',
  async (url: string, { rejectWithValue }) => {
    try {
      const response = await getProductDetailByUrl(url);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);
